<template>
	<el-dialog 
		:lang="$i18n.locale" 
		:title="$t('commonInfo.orderType')" 
		:visible.sync="visible" 
		width="940px" 
        @close="handleCloseDialog"
		:close-on-click-modal="false"
	>
		<el-row :gutter="20">
			<el-col :span="12">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>{{$t('commonInfo.fleetanWarehouse') + ' ' + $t('ksaWhFBXOrderPage.skuFulfillment') }}</span>
					</div>
					<el-row style="height: 80px;"><span>{{$t('ksaWhFBXOrderPage.skuFulfillmentTips')}}</span></el-row>
					<el-row style="text-align: center;margin: 10px 0;"><el-button type="primary" @click="ChooseCreateType('1')" style="margin-left:10px;">{{$t('commonInfo.createBtn')}}</el-button></el-row>
				</el-card>
			</el-col>
			<el-col :span="12">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>{{$t('commonInfo.fleetanWarehouse') + ' ' + $t('ksaWhFBXOrderPage.cartonFulfillment') }}</span>
					</div>
					<el-row style="height: 80px;"><span>{{$t('ksaWhFBXOrderPage.cartonFulfillmentTips')}}</span></el-row>
					<el-row style="text-align: center;margin: 10px 0;"><el-button type="primary" @click="ChooseCreateType('2')" style="margin-left:10px;">{{$t('commonInfo.createBtn')}}</el-button></el-row>
				</el-card>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
export default {
	name: 'ChooseCreateType',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
	},
	methods: {
		ChooseCreateType(type) {
			this.$emit('update:visible', false);
			this.$emit('chooseType', type);
		},
        handleCloseDialog(){
            this.$emit('update:visible', false);
        },
	}
};
</script>

<style scoped>
.box-card {
	margin: 10px;
}

/* 阿拉伯语样式 */
[lang="ar"] {
	::v-deep .el-dialog__headerbtn{
		right: auto;
		left: 20px;
	}
	
	.box-card {
		margin: 10px;
	}
}
</style>